// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__AqgGa","header":"ReportDetails_header__2kV3Q","title":"ReportDetails_title__2oYM8","left":"ReportDetails_left__1s-h-"};